import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { NotificationType } from '../misc/enums/notification-type.enum';
import { PermissionHandlerService } from './permission-handler.service';
import { Router } from '@angular/router';
import { TranslatorPipe } from './translator.pipe';

@Injectable({
  providedIn: 'root'
})
export class NotificationHandlerService {

  translator: TranslatorPipe = new TranslatorPipe();

  userCreatedAt: Date = new Date();

  constructor(
    private permissionService: PermissionHandlerService,
    private router: Router

  ) {
    const userCreatedAt = localStorage.getItem('createdAt');
    if (!!userCreatedAt) {
      this.userCreatedAt = new Date(userCreatedAt);
    }
  }

  private notificationSubject: Subject<any> = new Subject<any>();


  public addNotification(notification: any) {
    this.notificationSubject.next(notification);
  }

  public addNotifications(notificaitons: any) {
    notificaitons.forEach((notification: any) => {
      this.notificationSubject.next(notification);
    });
  }

  public getNotifications(): Observable<any> {
    return this.notificationSubject.asObservable();
  }

  public setNotificationTypeMessage(notification: any) {
    let ous: any[] = notification?.sender?.ou;
    if (Array.isArray(ous) && ous.length > 0) {
      notification.name = ous[0]?.name
    }
    notification.message = this.translator.transform(notification.type)
    if (notification.type == NotificationType.COMMENT_REPLY) {
      notification.link = "/admin/comments";
      notification.title = notification?.data?.ou?.name;
      notification.image = notification?.data?.ou?.image;
    } else if (notification.type == NotificationType.CONTENT_RECEIVED_FOR_APPROVAL) {
      notification.link = "/update";
      notification.title = notification?.data?.ou?.name;
      notification.image = notification?.data?.ou?.image;
    } else if (notification.type == NotificationType.DATA_UPDATE) {
      notification.title = notification?.data?.ou?.name;
      notification.image = notification?.data?.ou?.image;
      let name = notification?.data.updated_by.name;
      notification.name = name?.first + ' ' + name?.middle + ' ' + name?.last;
      notification.link = `/data/${notification?.data?.before?.dataview?.id}`
    } else if (notification.type == NotificationType.KLIBRARY_NOTIFICATION) {
      notification.link = "/knowledge-library"
      notification.title = notification.data?.name;
      notification.image = notification.data?.image;
    } else if (notification.type == NotificationType.NEW_COMMENT) {
      notification.link = "/admin/comments";
      notification.title = notification?.data?.ou?.name;
      notification.image = notification?.data?.ou?.image;
    } else if (notification.type == NotificationType.USER_REGISTER) {
      notification.link = "/admin/users"
      notification.image = notification?.sender?.image;
    } else if (notification.type == NotificationType.SURVEY) {
      notification.link = "/sa/survey/attempt/" + notification?.data?._id
      notification.image = notification?.data?.headerImage;
      notification.title = notification?.data?.name;
    } else if (notification.type == NotificationType.ASSESSMENT) {
      notification.link = "/sa/assessment/attempt/" + notification?.data?._id
      notification.image = notification?.data?.headerImage;
      notification.title = notification?.data?.name;
      //Training cases
    } else if (notification.type == NotificationType.NEW_SKILL_TRAINING_CREATE) {
      notification.link = `training/skill-training/${notification?.data?.data?.type}`;
      notification.image = "/public/training/fdafdajdsklafdfaf.png"
      notification.title = notification?.data?.data?.topic;
    } else if (notification.type == NotificationType.NEW_SKILL_SELF) {
      notification.link = "/user-profile";
      notification.image = notification?.data?.course?.image;
      notification.title = notification?.data?.course.title;
    } else if (notification.type == NotificationType.NEW_SKILL_MANAGER) {
      notification.link = `/training/skill-training/${notification?.data?.data?.type}`;
      notification.image = notification?.data?.course?.image;
      notification.title = notification?.data?.course.title;
    } else if (notification.type == NotificationType.NEW_SKILL_CANCELLED) {
      notification.link = "";
      notification.image = notification?.data?.course?.image;
      notification.title = notification?.data?.data?.topic;
    } else if (notification.type == NotificationType.CONTINUOUS_TRAINING_CREATE) {
      notification.link = "/training/task-view";
      notification.image = "/public/training/fdafdajdsklafdfaf.png"
      notification.title = notification?.data?.data?.topic;
    } else if (notification.type == NotificationType.CONTINUOUS_TRAINING_PUBLISH) {
      notification.link = `/training/training-page/${notification?.data?.course._id}`;
      notification.image = notification?.data?.course?.image;
      notification.title = notification?.data?.data?.topic;
    } else if (notification.type == NotificationType.BRANCH_TRAINING_CREATE) {
      notification.link = "/training/new-branch";
      notification.image = "/public/training/fdafdajdsklafdfaf.png"
      notification.title = notification?.data?.data?.topic;
    } else if (notification.type == NotificationType.BRANCH_TRAINING_PUBLISH) {
      console.log('BRANCH NOTIFICAITON', notification, notification?.data?.course._id)
      notification.link = `/training/training-page/${notification?.data?.course._id}`;
      notification.image = notification?.data?.course?.image;
      notification.title = notification?.data?.data?.topic;
    } else if (notification.type == NotificationType.CUSTOM_NOTIFICATION) {
      notification.link = `/training/training-page/${notification?.data?.course._id}`;
      notification.image = notification?.data?.course?.image;
      notification.title = notification?.data?.course?.title;
      notification.message = notification?.data?.message;
    } else if (notification.type == NotificationType.COURSE_ADD_REQUEST) {
      notification.link = `/training/skill-training/${notification?.data?.type}`;
      notification.title = notification?.data?.data?.topic;
    } else if (notification.type == NotificationType.TRAINER_ADDED) {
      notification.link = `/training/training-page/${notification?.data?._id}`;
      notification.image = notification?.data?.image;
      notification.title = notification?.data?.title;
    } else if (notification.type == NotificationType.MASTER_TRAINER_ADDED) {
      notification.link = `/training/training-page/${notification?.data?._id}`;
      notification.image = notification?.data?.image;
      notification.title = notification?.data?.title;
    }
    return notification;
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  navigateToRoute(notification: any) {
    console.log(notification);
    if (!!notification.link) {
      if (notification.type == NotificationType.DATA_UPDATE) {
        console.log(notification);
        // let ouId = notification?.data?.ou?.id;
        // let queryParams = { dataId: notification?.data?.before?.dataview?.id, first: 0 };
        // this.router.navigate(['/category/' + ouId], { queryParams });
        this.router.navigate([`/data/${notification?.data?.before?.dataview?.id}`])
      } else if (notification.type == NotificationType.SURVEY) {
        window.open(notification.link, '_blank');
      } else if (notification.type == NotificationType.TRAINER_ADDED || notification.type == NotificationType.CUSTOM_NOTIFICATION || notification.type == NotificationType.MASTER_TRAINER_ADDED) {
        let queryParams = { _id: notification?.data?._id };
        this.router.navigate(['/training/training-page/' + notification?.data?._id], { queryParams });
      } else if (notification.type == NotificationType.BRANCH_TRAINING_PUBLISH) {
        let queryParams = { _id: notification?.data?.course?._id };
        this.router.navigate(['/training/training-page/' + notification?.data?.course?._id], { queryParams });
      } else {
        this.router.navigate([notification.link]);
      }
    }
  }


  applyPermissions(notification: any) {
    if (notification.type == NotificationType.COMMENT_REPLY || notification.type == NotificationType.NEW_COMMENT) {
      return this.permissionService.hasPermission('COMMENTS', 'r');
    } else if (notification.type == NotificationType.CONTENT_RECEIVED_FOR_APPROVAL) {
      return this.permissionService.hasPermission('CONTENT_APPROVE', 'a');
    } else if (notification.type == NotificationType.DATA_UPDATE) {
      return this.permissionService.hasPermission('DATA', 'a') ||
        this.permissionService.hasPermission('CONTENT', 'r');
    } else if (notification.type == NotificationType.KLIBRARY_NOTIFICATION) {
      return this.permissionService.hasPermission('KNOWLEDGE_LIBRARY', 'r');
    } else if (notification.type == NotificationType.USER_REGISTER) {
      return this.permissionService.hasPermission('USER_MANAGEMENT', 'r');
    } else if (notification.type == NotificationType.SURVEY) {
      return this.permissionService.hasPermission('SURVEY', 'r');
    } else if (notification.type == NotificationType.ASSESSMENT) {
      return this.permissionService.hasPermission("ASSESSMENT", "r");
    }
    //Training Cases
    else if (notification.type == NotificationType.CONTINUOUS_TRAINING_CREATE) {
      return this.permissionService.hasPermission('CONTINUOUS_TRAINING', 'r');
    } else if (notification.type == NotificationType.BRANCH_TRAINING_CREATE) {
      return this.permissionService.hasPermission('NEW_BRANCH_TRAINING', 'r');
    } else if (notification.type == NotificationType.NEW_SKILL_TRAINING_CREATE) {
      return this.permissionService.hasPermission('SKILL_TRAINING_PUBLISH', 'a');
    } else if (notification.type == NotificationType.NEW_SKILL_MANAGER) {
      return this.permissionService.hasPermission('SKILL_TRAINING', 'r');
    } else if ([NotificationType.NEW_SKILL_SELF,
    NotificationType.NEW_SKILL_CANCELLED,
    NotificationType.CONTINUOUS_TRAINING_PUBLISH,
    NotificationType.BRANCH_TRAINING_PUBLISH,
    NotificationType.CUSTOM_NOTIFICATION].includes(notification.type)) {
      return true;
    } else if ([NotificationType.TRAINER_ADDED, NotificationType.MASTER_TRAINER_ADDED].includes(notification.type)) {
      return true;
    }
    return false;
  }

  applyDatePermission(n: any) {
    let nCreatedAt = new Date(n.createdAt)
    return nCreatedAt.getTime() > this.userCreatedAt?.getTime();
  }
}
